import { render, staticRenderFns } from "./RevenueAndShare.vue?vue&type=template&id=dab7d226&scoped=true&"
import script from "./RevenueAndShare.vue?vue&type=script&lang=js&"
export * from "./RevenueAndShare.vue?vue&type=script&lang=js&"
import style0 from "./RevenueAndShare.vue?vue&type=style&index=0&id=dab7d226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab7d226",
  null
  
)

export default component.exports